import React from 'react'
import { Tag, Badge } from 'antd'
import { RateSetStatus as Status } from '../Form/types/ratesets'

interface Props {
  status: Status
}

const RateSetStatus: React.FunctionComponent<Props> = ({ status }) => {
  return (
    <Tag color={status.color}>
      <Badge status={status.status} text={status.text} />
    </Tag>
  )
}

export default RateSetStatus
